import { Link } from "react-router-dom";
import { MapPin, ArrowRight, ShieldCheck, Info, Star } from "lucide-react";

export const CompanyCard = ({ company, compact = false }) => {
  const status = company.listing_status || "referenced";
  const isPartner = status === "partner" || status === "partner_verified";
  const isVerified = status === "partner_verified";
  return (
    <Link
      to={`/demenageur/${company.slug}`}
      className="card-clean block group relative"
      data-testid={`company-card-${company.slug}`}
    >
      {isPartner ? (
        <div className="absolute -top-3 left-6 px-3 py-1 bg-[#2BD391] text-white text-[10px] font-bold uppercase tracking-widest rounded-full shadow-md flex items-center gap-1" data-testid={`card-badge-partner-${company.slug}`}>
          <ShieldCheck className="w-3 h-3" /> {isVerified ? "Recommandée" : "Partenaire"}
        </div>
      ) : (
        <div className="absolute -top-3 left-6 px-3 py-1 bg-white text-[#5C6B7A] border border-[#E5E7EB] text-[10px] font-bold uppercase tracking-widest rounded-full shadow-sm flex items-center gap-1" data-testid={`card-badge-referenced-${company.slug}`}>
          <Info className="w-3 h-3" /> Référencée
        </div>
      )}

      <div className="flex items-start justify-between gap-3 mb-3 mt-2">
        <h3 className="font-heading font-extrabold text-xl leading-tight text-[#2C3E50] group-hover:text-[#1AA66C] transition-colors">
          {company.name}
        </h3>
      </div>

      {!compact && (
        <p className="text-sm text-[#6B7280] leading-relaxed line-clamp-2 mb-5">
          {isPartner
            ? `Entreprise recommandée à ${company.city}. Devis rapide via Déménageur Pro.`
            : `Entreprise de déménagement référencée à ${company.city} à partir de données publiques.`}
        </p>
      )}

      <div className="space-y-2 text-xs text-[#6B7280] mb-4">
        <div className="flex items-center gap-2">
          <MapPin className="w-3.5 h-3.5 text-[#2BD391]" />
          <span>{company.city} · {company.postal_code}</span>
        </div>
        {isPartner && company.rating > 0 && (
          <div className="flex items-center gap-1.5" data-testid={`card-rating-${company.slug}`}>
            <span className="bg-[#4285F4] text-white text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full">Google</span>
            <Star className="w-3.5 h-3.5 fill-[#FBBC04] text-[#FBBC04]" />
            <span className="font-bold text-[#2C3E50]">{company.rating.toFixed(1)}</span>
            <span className="text-[10px]">({company.review_count} avis)</span>
          </div>
        )}
      </div>

      {company.services?.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-4 pt-4 border-t border-[#F0F2F5]">
          {company.services.slice(0, 3).map((s) => (
            <span key={s} className="text-[11px] px-2.5 py-1 bg-[#F7F9FB] text-[#2C3E50] font-medium rounded-full">
              {s}
            </span>
          ))}
        </div>
      )}

      <div className="mt-5 flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#2BD391] group-hover:gap-2.5 transition-all">
          Voir la fiche <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  );
};
